const delistedRoutePrefixes = [
  '/partner-activity-lead',
  '/partner-schedule',
  '/tokenomics-and-launch-research',
]

const delistedRoutes = new Set([
  '/playbook',
  '/playbook-advanced',
])

/**
 * Returns whether a route has been delisted from search and direct access.
 * Project-scoped routes use the same checks after their /project/:id prefix.
 */
export function isDelistedRoute(path: string): boolean {
  const projectPrefix = path.match(/^\/project\/[^/]+/)?.[0] ?? ''
  const routePath = path.slice(projectPrefix.length)

  if (delistedRoutes.has(routePath)) {
    return true
  }

  return delistedRoutePrefixes.some(prefix => routePath === prefix || routePath.startsWith(`${prefix}/`))
}
